import React from "react";

export default function MyTime(){
    return <div className="main">
    <div className = "grid-container">
         <div className = "tittle-wrapper">
           <h2>— Education</h2>
         </div>
           <div className="item-mini">    
               <h4>Web and Mobile Dev.</h4>
               <span>Cornerstone College</span><br/>
               <span>Vancouver, Canada - 2019</span>
               <br/>
               <br/>
               <h4>Bachelor of Engineering - Industrial Design</h4>
               <span>UTM - Tech University of Moldova</span><br/>
               <span>Chisinau, Moldova - 2012-2016</span>
           </div>
           <div className = "tittle-wrapper-skills">
             <h2>— Skills</h2>
           </div>
           <div className="item">
           <div className="skill-item">
               <div className="text-wrapper">
                 <h4>Research</h4>
                 <span>
                 -Deep data analysis<br/>
                 -Usability analysis<br/>
                 -Comparative analysis<br/>
                 -Statistical analysis
                 </span>
               </div>
               <div className="text-wrapper">
                 <h4>Language</h4>
                 <span>
                 English<br/>
                 Russian<br/>
                 Romanian<br/>
                 Sign Language 
                 </span>
               </div> 
               <div className="text-wrapper">
                   <h4>Development</h4>
                   <span>
                   HTML/CSS<br/>
                   JavaScript/React<br/>
                   Node.js<br/>
                   Multitasking<br/>
                   Windows/Linux<br/>
                   Prototyping<br/>
                   SPA Design<br/>
                   UI/UX Design
                   </span>
               </div>
               <div className="text-wrapper">
                 <h4>Tools</h4>
                 <span>
                 Photoshop<br/>
                 VS code<br/>
                 Illustrator<br/>
                 Figma<br/>
                 3DS Max<br/>
                 SolidWorks<br/>
                 KeyShot
                 </span>
               </div>  
           </div>
           </div>
     </div>
     <div className = "grid-container">
         <div className = "tittle-wrapper">
           <h2>— Work Accomplished</h2>
         </div>
         <div className="item">    
               <h4>Glossa Studio</h4>
               <h4>Junior UI/UX Designer</h4>
               <span>Apr 2016 - May 2018 - Chisinau, Moldova</span>
         </div>
           <div className="item">
               <span>Integration, and UI tests<br/></span>
               <span>Designed Icons/Invitations/AdBanners<br/></span>
               <span>Analyzing target audience for proper content structuring<br/></span>
               <span>Analyzing User action map<br/></span>
               <span>Working on wireframing and page layouts<br/></span>
               <span>UX testing Quote Form for macback.us<br/></span>
               <span>HTML/CSS/JS for artizanafashion.md/macback.us<br/></span>
               <span>Creating preview prototypes <br/></span>
           </div>
           <div className="item">
             <h4>Freelance</h4>
             <h4>Engineer / Automation Manager</h4>
             <span>Apr 2011 - Apr 2015 - Chisinau, Moldova</span>
           </div>
           <div className="item">
             <span>Analyzing User mislead experience<br/></span> 
             <span>Testing usability defects<br/></span> 
             <span>Creating Ad compainings for getting leads. <br/></span>
             <span>Prototyping new strategy to cover User mislead<br/></span>
             <span>Creating Web automation strategy<br/></span>
             <span>Implementing test automation<br/></span>
             <span>Using continuous integration<br/></span>
           </div>
     </div>
     </div> 
}
